var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "searchView" }, [
    _c(
      "div",
      { staticClass: "search_box" },
      [
        _c("el-input", {
          staticClass: "search_input",
          attrs: { placeholder: "请输入关键字进行搜索" },
          model: {
            value: _vm.keyword,
            callback: function($$v) {
              _vm.keyword = $$v
            },
            expression: "keyword"
          }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "search_btn" }, [_vm._v("搜索")])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e67d1a5e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e67d1a5e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/SearchView.vue
// module id = null
// module chunks = 